export const API_URL = 'https://epatazhnost.ru/api_v1';

export const API_URL_PHOTO = 'https://epatazhnost.ru';

